import { createSlice } from "@reduxjs/toolkit";

const toggleSidebarSlice = createSlice({
    name: 'toggleSidebar',
    initialState: {
        showSidebar: true,
    },
    reducers: {
        toggleSidebar: (state) => {
            state.showSidebar = !state.showSidebar; 
        },
    },
});

export const { toggleSidebar } = toggleSidebarSlice.actions;

export const selectShowSidebar = (state) => state.toggleSidebar.showSidebar;

export default toggleSidebarSlice.reducer;
